import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(private storage: StorageService) {
  }

  authStatus() {
    const token = this.storage.get('token');
    if (token !== null && token !== undefined) {
      this.isAuthenticated.next(true);
      return token;
    } else {
      this.isAuthenticated.next(false);
      return null;
    }
  }

  getToken() {
        const token = this.storage.get('token');
    return token;
  }  

  getUser(){  
    const user = this.storage.get('user_data')? JSON.parse(this.storage.get('user_data')||'{}'):null;
    return user;
  }
}
